import { TableCell } from '@mui/material';
import { Menu, MenuItem, Tooltip, ToggleButton } from '@mui/material';
import { useState } from 'react';
import { RouteInformation } from '../../shared/constants/RouteInformation';
import { TrackerDataType } from '../../shared/constants/constants';
import MoreOptionsIcon from '../TrackerFilter/Icons/MoreOptionsIcon';
import EditPencilIcon from '../TrackerFilter/Icons/EditPencilIcon';
import CopyUrlIcon from '../TrackerFilter/Icons/CopyUrlIcon';
import DuplicateIcon from '../TrackerFilter/Icons/DuplicateIcon';

export default function TrackerTableEditorCell({
  handleEditMode,
  onDuplicate,
  className,
  showDuplicate = false,
  type,
  rowId,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCopyUrl = () => {
    navigator.clipboard.writeText(
      `${window.location.origin}${
        type === TrackerDataType.MEDIA_INTERACTION
          ? RouteInformation.mediaInteraction.path
          : type === TrackerDataType.ENGAGEMENT
          ? RouteInformation.engagementLog.path
          : RouteInformation.serviceLog.path
      }/${rowId}`
    );
    handleClose();
  };

  return (
    <TableCell className={className}>
      <Tooltip title="More options" placement="left">
        <ToggleButton
          value="more-options"
          selected={open}
          onChange={handleClick}
          size="small"
          sx={{
            color: (theme) => theme.palette.primaryDefault.main,
            border: 'none',
            padding: '0',
            borderRadius: '50%',
            width: '22px',
            height: '22px',
            transition: 'all 0.2s ease-in-out',
            '& .MuiSvgIcon-root': {
              width: '26px',
              height: '26px',
            },
            '&.Mui-selected': {
              backgroundColor: (theme) => theme.palette.primaryDark.main,
              color: (theme) => theme.palette.primaryDark.contrastText,
              '&:hover': {
                backgroundColor: (theme) => theme.palette.primaryDark.main,
              },
            },
            '&:hover': {
              color: (theme) => theme.palette.toneNeutral.main,
            },
          }}
        >
          <MoreOptionsIcon />
        </ToggleButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            handleEditMode(true);
            handleClose();
          }}
        >
          <EditPencilIcon sx={{ mr: 1, color: (theme) => theme.palette.toneNeutral.main }} /> Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleCopyUrl();
            handleClose();
          }}
        >
          <CopyUrlIcon sx={{ mr: 1, color: (theme) => theme.palette.toneNeutral.main }} /> Copy URL
        </MenuItem>
        {showDuplicate && (
          <MenuItem
            onClick={() => {
              onDuplicate();
              handleClose();
            }}
          >
            <DuplicateIcon sx={{ mr: 1, color: (theme) => theme.palette.toneNeutral.main }} /> Duplicate
          </MenuItem>
        )}
      </Menu>
    </TableCell>
  );
}
